import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { HttpClientModule } from '@angular/common/http';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from "primeng/tooltip";
import { DividerModule } from 'primeng/divider';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FileUploadModule } from 'primeng/fileupload';
import { RippleModule } from 'primeng/ripple';
import { ChipModule } from 'primeng/chip';
import { EditorModule } from 'primeng/editor';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { InputMaskModule } from 'primeng/inputmask';
import { FormsModule } from '@angular/forms';
import { TabViewModule } from 'primeng/tabview';
import { EmpresaListarModule } from '../../empresas/empresa-listar/empresa-listar.module';
import { AdministradoraEditarComponent } from './administradora-editar.component';
import { AdministradoraEditarRoutingModule } from './administradora-editar-routing.module';
import { CheckboxModule } from 'primeng/checkbox';
import { InputSwitch, InputSwitchModule } from 'primeng/inputswitch';
import { TreeTableModule } from 'primeng/treetable';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { UsuarioFranquiaRfariasAppModule } from '../../usuario-franquia-rfarias/usuario-franquia-rfarias.app.module';


@NgModule({
 
  imports: [
    AdministradoraEditarRoutingModule,
    CommonModule,
    FormsModule,
    UsuarioFranquiaRfariasAppModule,
    ButtonModule,
    InputTextModule,
    InputTextareaModule,
    FileUploadModule,
    RippleModule,        
    ChipModule,
    TableModule,
    EditorModule,
    HttpClientModule,        
    TooltipModule,
    DividerModule,
    SplitButtonModule,
    ConfirmDialogModule,
    InputMaskModule,
    TabViewModule,
    CheckboxModule,
    InputSwitchModule,
    DialogModule,
    TreeTableModule,
    DropdownModule
  ],
  providers: [
    ConfirmationService
  ],
  declarations: [
    AdministradoraEditarComponent
  ]
})
export class AdministradoraEditarModule { }
